import { render } from "./HrDashboard.vue?vue&type=template&id=124a572a"
import script from "./HrDashboard.vue?vue&type=script&lang=js"
export * from "./HrDashboard.vue?vue&type=script&lang=js"

import "./HrDashboard.styles.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__